import { useContext } from 'react';
import Header from '../components/Header';
import ProductCard from '../components/ProductCard';
import Footer from '../components/Footer';
import { CartContext } from '../context/CartContext';

const HomePage = () => {
  const { state, addToCart } = useContext(CartContext);

  return (
    <>
      <section className="py-1">
        <div className="container px-4 px-lg-5 mt-5">
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-4 justify-content-center">
            {state.products.map(product => (
              <ProductCard 
                key={product.id} 
                product={product} 
                addToCart={addToCart} 
              />
            ))}
          </div>
        </div>
      </section>

      {/* 👇 PIE DE PÁGINA */}
      <Footer />
    </>
  );
};

export default HomePage;

